angular
  .module("admin.campaigns")
  .controller("CampaignsListCtrl", function (CampaignsResource, $uibModal) {
    this.pagination = {
      page: 1,
      pageSize: 10,
    };

    this.campaigns = [];
    this.metadata = {};
    this.loading = false;

    this.loadCampaigns = function () {
      this.loading = true;
      var params = {
        page: this.pagination.page,
        limit: this.pagination.pageSize,
      };

      CampaignsResource.query(params, (response) => {
        this.loading = false;
        if (response && response.data) {
          this.campaigns = response.data.data || [];
          this.metadata = response.data.metadata || {};
          return;
        }

        this.campaigns = [];
        this.metadata = {};
      });
    };

    this.createCampaign = function () {
      $uibModal
        .open({
          templateUrl: "views/campaigns/edit.html",
          controller: "CampaignsEditModalCtrl",
          controllerAs: "ctrl",
          resolve: {
            mode: () => "create",
            campaignId: null,
          },
        })
        .result.then(() => this.loadCampaigns());
    };

    this.edit = function (cp) {
      $uibModal
        .open({
          templateUrl: "views/campaigns/edit.html",
          controller: "CampaignsEditModalCtrl",
          controllerAs: "ctrl",
          resolve: {
            mode: () => "edit",
            campaignId: cp.id,
          },
        })
        .result.then(() => this.loadCampaigns());
    };

    this.loadCampaigns();
  })
  .config(function ($stateProvider) {
    $stateProvider.state("admin.campaigns", {
      url: "campaigns",
      controller: "CampaignsListCtrl",
      controllerAs: "ctrl",
      templateUrl: "views/campaigns/view.html",
      data: {
        permissions: {
          only: "admin.campaigns",
        },
      },
    });
  });
